export default __webpack_public_path__ + "static/media/content.aab646cc.png";